import { z } from 'zod'

export const PromotionUxSignalProductSchema = z.enum(['HOTEL', 'CAR_HIRE', 'EXPERIENCE'])

export const PromotionUxSignalResponseSchema = z.object({
  promotions: z.array(z.string()),
})

export const PromotionUxSignalMemberSchema = z.object({
  memberId: z.string().trim().min(1).optional(),
})

export type PromotionUxSignalProduct = z.infer<typeof PromotionUxSignalProductSchema>
export type PromotionUxSignalResponse = z.infer<typeof PromotionUxSignalResponseSchema>
